<ad-detail-group-tag>
    <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
        {props.item.title}
    </h2>
    <div each="{group in props.item.items}"">
        <h3 class="heading-05 margin-spacing-2_bottom">{group.title}</h3>
        <div each="{ cateogry in group.items }">
            <h3 class="heading-04 margin-spacing-2_bottom">{cateogry.title}</h3>
            <ul class="scope_list margin-spacing-2_bottom">
                <li class="scope_list-item" each="{ title in cateogry.items }">
                    <span class="skill_label">{title}</span>
                </li>
            </ul>
        </div>
    </div>
    <script>
        export default {
            onMounted(props, state) {
           }
        }
    </script>
</ad-detail-group-tag>
